import * as go from 'gojs';
import { toggleTextOnTextEditing } from '../../../../../utils/toggle-text-on-text-editing';
import { registerNodeTemplate } from '../../common/utils/registerNodeTemplate';
import { nodeGroupNodeTemplate } from '../node-group-node';
import { finishDrop } from './../utils/group-utils';

export const setupNodeGroupNode = (diagram: go.Diagram, categoryName: string) => {
  registerNodeTemplate(diagram, categoryName, nodeGroupNodeTemplate());
  overrideMouseDrop(diagram, categoryName);
  toggleTextOnTextEditing(diagram, categoryName);
  return registerDiagramListeners(diagram, categoryName);
};

const registerDiagramListeners = (diagram: go.Diagram, categoryName: string) => {
  const onSelectionDeleting = handleSelectionDeleting(categoryName);
  diagram.addDiagramListener('SelectionDeleting', onSelectionDeleting);

  return () => {
    diagram.removeDiagramListener('SelectionDeleting', onSelectionDeleting);
  };
};

const handleSelectionDeleting =
  (categoryName: string) =>
  ({ diagram, subject }: go.DiagramEvent) => {
    const iterator = (subject as go.Set<go.Part>)?.iterator;
    if (!iterator) {
      return;
    }

    while (iterator.next()) {
      const part = iterator.value;
      if (part?.category !== categoryName || !(part instanceof go.Group)) {
        continue;
      }

      diagram.commandHandler.addTopLevelParts(part.memberParts);
    }
  };

const overrideMouseDrop = (diagram: go.Diagram, categoryName: string) => {
  const mouseDropBase = diagram.mouseDrop?.bind(diagram);
  diagram.mouseDrop = (e: go.InputEvent) => {
    if (mouseDropBase) {
      mouseDropBase.call(diagram, e);
    }
    finishDrop(e, null, categoryName);
  };
};
